import { getSize, styleVariables } from '@lib/common';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { getAnswerGradingVisualStatus } from '../utils/get-answer-grading-visual-status';
import { getAnswerStatusColorTooltip } from '../utils/get-answer-status-color-tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledResultTag = styled.div.withConfig({
  displayName: "grading-tagcomponent__StyledResultTag",
  componentId: "sc-1c4ogzp-0"
})(["display:inline-flex;align-items:center;justify-content:center;padding:", " ", ";font-size:", ";color:", ";background:", ";border-radius:999px;font-weight:600;"], getSize('padding4'), getSize('padding8'), getSize('typo12'), function (props) {
  switch (props.$status) {
    case 'correct':
      return styleVariables.colors.green1;

    case 'manuallyAwarded':
      return styleVariables.colors.gold1;

    case 'skipped':
      return styleVariables.colors.green1;

    default:
      return styleVariables.colors.red3;
  }
}, function (props) {
  switch (props.$status) {
    case 'correct':
      return styleVariables.colors.green2;

    case 'manuallyAwarded':
      return '#FFF7E6';

    case 'skipped':
      return styleVariables.colors.green2;

    default:
      return styleVariables.colors.red10;
  }
});
export var GradingTagComponent = function GradingTagComponent(_ref) {
  var isSkipped = _ref.isSkipped,
      hasAnswer = _ref.hasAnswer,
      isCorrect = _ref.isCorrect,
      label = _ref.label,
      score = _ref.score,
      hasGraded = _ref.hasGraded;

  var renderTag = function renderTag() {
    var status = getAnswerGradingVisualStatus({
      isSkipped: isSkipped,
      hasAnswer: hasAnswer,
      isCorrect: isCorrect,
      score: score,
      hasGraded: hasGraded
    });

    if (status === 'ungraded' || !hasAnswer && status !== 'skipped') {
      return null;
    }

    var tagContent = null;

    if (status === 'skipped') {
      tagContent = /*#__PURE__*/_jsx(StyledResultTag, {
        $status: status,
        children: label.skipped
      });
    } else if (status === 'correct') {
      tagContent = /*#__PURE__*/_jsx(StyledResultTag, {
        $status: status,
        children: label.correct
      });
    } else if (status === 'manuallyAwarded') {
      // Keep "Incorrect" wording for key mismatch, but use warning color to show teacher awarded points.
      tagContent = /*#__PURE__*/_jsx(StyledResultTag, {
        $status: status,
        children: label.inCorrect
      });
    } else {
      tagContent = /*#__PURE__*/_jsx(StyledResultTag, {
        $status: status,
        children: label.inCorrect
      });
    }

    var tooltipTitle = getAnswerStatusColorTooltip(status, {
      correct: label.colorStatusCorrect,
      incorrect: label.colorStatusIncorrect,
      customGrade: label.customGrade,
      skipped: label.skipped
    });
    return tooltipTitle ? /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipTitle,
      children: tagContent
    }) : tagContent;
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderTag()
  });
};